import styled from 'styled-components';

export const NavBarWrapper = styled.div`
  padding: 30px 16px 10px;
  background: #f8f9fa;
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  padding-bottom: 6px;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    margin-top: 6px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: var(--scroll-color);
  }

  @media (max-width: 768px) {
    border-bottom: 1px solid #e0e0e0;
    padding: 20px 16px;
  }
`;

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
  min-width: 100%;
  width: max-content;
`;

export const PillButton = styled.button`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 177px;
  height: 42px;
  padding: 0 14px;
  border-radius: 20px;
  border: 1.5px solid #e0e0e0;
  background: #fff;
  cursor: pointer;
  flex-shrink: 0;
  overflow: hidden;
  transition: border-color 0.2s, background 0.2s;
  outline: none;

  &:hover {
    border-color: #1a295a;
    background: #eef1f8;
  }

  @media (max-width: 768px) {
    width: 42px;
    padding: 0;
    gap: 0;
  }
`;

export const PillIcon = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: #ce6239;

  img {
    width: 32px;
  }
`;

export const PillLabel = styled.span`
  font-size: 16px;
  color: #1a295a;
  font-weight: 400;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;

  @media (max-width: 768px) {
    display: none;
  }
`;
